import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
const appLauncherCardListContext = createContext({
  actionSize: "medium"
});
function AppLauncherCardListContextProvider(props) {
  const { actionSize = "medium", children, showDescriptions = true } = props;
  const contextValue = useMemo(
    () => ({
      actionSize,
      showDescriptions
    }),
    [actionSize, showDescriptions]
  );
  return /* @__PURE__ */ jsx(appLauncherCardListContext.Provider, { value: contextValue, children });
}
function useAppLauncherCardList() {
  return useContext(appLauncherCardListContext);
}
export {
  AppLauncherCardListContextProvider,
  appLauncherCardListContext,
  useAppLauncherCardList
};
//# sourceMappingURL=AppLauncherCardListContextProvider.js.map
